export {
  CarReviewsV2Feature as default,
  getStaticProps,
  getStaticPaths,
} from '@cinch-nx/landing-feature-car-reviews-v2'
